import { render, staticRenderFns } from "./Collaborations.vue?vue&type=template&id=2914c660"
import script from "./Collaborations.vue?vue&type=script&lang=js"
export * from "./Collaborations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports